var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-order-line-page"}},[_c('add-order-line',{attrs:{"profile-id-param":_vm.profileIdParam,"product-id-param":_vm.productIdParam},on:{"finished":_vm.goBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }